// extracted by mini-css-extract-plugin
export default {"PopularDogBreed":"PopularDogBreed_PopularDogBreed__87gDp","link":"PopularDogBreed_link__BUH6P","viewAll":"PopularDogBreed_viewAll__staYD"};